import { thumbnail, placeholderThumb } from "../../../functions/thumbnail";

export default {
  props: {
    fileInfo: Object,
  },
  methods: {
    thumb() {
      return thumbnail(this.fileInfo);
    },
    onError() {
      return placeholderThumb();
    },
  },
};
